import { connect } from "react-redux";

import SegmentsAnalysisAdvancedEmptyWrapper from "app/pages/segments/analysis/SegmentsAnalysisAdvancedEmpty";
import SegmentsGroupAnalysisOverviewContainer from "app/pages/segments/analysis/SegmentsGroupAnalysisOverviewContainer";
import SegmentsSingleAnalysisContainer from "app/pages/segments/analysis/SegmentsSingleAnalysisContainer";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type {
    ICustomSegment,
    ICustomSegmentAccount,
    ICustomSegmentsMetaData,
} from "app/services/segments/segmentsApiService";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";

import { MODE } from "./SegmentsAnalysisTrafficContainerMode";

interface ISegmentsAnalysisTrafficContainer {
    params: any;
    segments: ICustomSegment[];
    organizationSegments: ICustomSegmentAccount[];
    customSegmentsMeta: ICustomSegmentsMetaData;
    isLoading: boolean;
}

const SegmentsAnalysisTrafficContainer = (props: ISegmentsAnalysisTrafficContainer) => {
    const { params } = props;
    let ComponentToRender = null;
    switch (params?.mode) {
        case MODE.single:
            ComponentToRender = SegmentsSingleAnalysisContainer;
            break;
        case MODE.group:
            const isMidTierUser = SegmentsUtils.isMidTierUser();
            if (isMidTierUser) {
                proNavigator.go("digitalsuite_segments-homepage");
            } else {
                ComponentToRender = SegmentsGroupAnalysisOverviewContainer;
            }
            break;
    }
    return ComponentToRender ? (
        <SegmentsAnalysisAdvancedEmptyWrapper>
            <ComponentToRender {...props} />
        </SegmentsAnalysisAdvancedEmptyWrapper>
    ) : null;
};

function mapStateToProps(store) {
    const {
        segmentsModule: { customSegmentsMeta, segmentsLoading },
    } = store;
    const { params } = store.routing;
    return {
        segments: customSegmentsMeta?.Segments,
        organizationSegments: customSegmentsMeta?.AccountSegments,
        customSegmentsMeta: customSegmentsMeta,
        params,
        isLoading: segmentsLoading,
    };
}

export default connect(mapStateToProps, undefined)(SegmentsAnalysisTrafficContainer);
